import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchOrder } from "../../../store/action/orderAction";
import imageDefault from '../../../assets/images/svg/ic-image-default.svg';
import { formatPrice } from "../../../services/helpers/Helper";
import NotFound from "./not-found";

const ThankYou = (props) => {
   const { fetchOrder, order } = props;
   const params = useParams();
   const { id } = params;
   const [isLoad, setIsLoad] = useState(true);
   useEffect(() => {
      fetchOrder(id).finally(() => {
         setIsLoad(false)
      });
   }, [id]);

   return (
      <React.Fragment>
         {order.id && order.status == 2 ?
            <div className="payment-container">
               <div className=" flexbox">
                  <div className="content">

                     <div className="wrap">
                        <div className="main">
                           <div className="main-header">

                              <h1 className="logo-text">{order.campaign_name}</h1>

                           </div>
                           <div className="main-content">
                              <div>
                                 <div className="section">
                                    <div className="section-header os-header">
                                       <svg width="50" height="50" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#000"
                                          strokeWidth="2" className="hanging-icon checkmark">
                                          <path className="checkmark_circle"
                                             d="M25 49c13.255 0 24-10.745 24-24S38.255 1 25 1 1 11.745 1 25s10.745 24 24 24z"></path>
                                          <path className="checkmark_check" d="M15 24.51l7.307 7.308L35.125 19"></path>
                                       </svg>
                                       <div className="os-header-heading">
                                          <h2 className="os-header-title">
                                             Đặt hàng thành công
                                          </h2>
                                          <span className="os-order-number">
                                             Mã đơn hàng #{order.reference_code}
                                          </span>
                                          <span className="os-description">
                                             Cám ơn bạn đã mua hàng!
                                          </span>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="section thank-you-checkout-info">
                                    <div className="section-content">
                                       <div className="content-box">
                                          <div className="content-box-row content-box-row-padding content-box-row-no-border">
                                             <h2>Thông tin đơn hàng</h2>
                                          </div>
                                          <div className="content-box-row content-box-row-padding">
                                             <div className="section-content">
                                                <div className="section-content-column">
                                                   <h3>Thông tin giao hàng</h3>
                                                   {order.shipping_full_name}
                                                   <br />
                                                   {order.shipping_phone}
                                                   <br />
                                                   <p>
                                                      {order.shipping_address}
                                                      <br />
                                                      {order.shipping_ward_name}
                                                      <br />
                                                      {order.shipping_district_name}
                                                      <br />
                                                      {order.shipping_province_name}
                                                      <br />
                                                   </p>
                                                   <h3>Phương thức thanh toán</h3>
                                                   <p>
                                                      {order.payment_method_name}
                                                   </p>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="order-info">
                                    <div className="sidebar-content">
                                       <div className="order-summary order-summary-is-collapsed">
                                          <h2>Tổng quan đơn hàng</h2>
                                          <div className="order-summary-sections">
                                             <div className="order-summary-section order-summary-section-product-list"
                                                data-order-summary-section="line-items">
                                                <table className="product-table">
                                                   <thead>
                                                      <tr>
                                                         <th scope="col"><span className="visually-hidden">Hình ảnh</span></th>
                                                         <th scope="col"><span className="visually-hidden">Mô tả</span></th>
                                                         <th scope="col"><span className="visually-hidden">Số lượng</span></th>
                                                         <th scope="col"><span className="visually-hidden">Giá</span></th>
                                                      </tr>
                                                   </thead>
                                                   <tbody>
                                                      {order.orderProducts.map((item, index) => {
                                                         return (
                                                            <tr className="product" key={index}>
                                                               <td className="product-image">
                                                                  <div className="product-thumbnail">
                                                                     <div className="product-thumbnail-wrapper">
                                                                        <img className="product-thumbnail-image" alt={item.product_name} src={item.product_image ? item.product_image : imageDefault} />
                                                                     </div>
                                                                     <span className="product-thumbnail-quantity" ariaHidden="true">{item.quantity}</span>
                                                                  </div>
                                                               </td>
                                                               <td className="product-description">
                                                                  <span className="product-description-name order-summary-emphasis">{item.product_name}</span>
                                                                  <span className="product-description-variant order-summary-small-text">
                                                                  </span>
                                                               </td>
                                                               <td className="product-quantity visually-hidden">{item.quantity}</td>
                                                               <td className="product-price">
                                                                  <span className="order-summary-emphasis">
                                                                     {formatPrice(item.product_price * item.quantity)} đ
                                                                  </span>
                                                               </td>
                                                            </tr>
                                                         )
                                                      })}
                                                   </tbody>
                                                </table>
                                             </div>
                                             <div className="order-summary-section order-summary-section-total-lines payment-lines">
                                                <table className="total-line-table">
                                                   <thead>
                                                      <tr>
                                                         <th scope="col">
                                                            <span className="visually-hidden">Mô tả</span>
                                                         </th>
                                                         <th scope="col">
                                                            <span className="visually-hidden">Giá</span>
                                                         </th>
                                                      </tr>
                                                   </thead>
                                                   <tbody>
                                                      <tr className="total-line total-line-subtotal">
                                                         <td className="total-line-name">Tạm tính</td>
                                                         <td className="total-line-price">
                                                            <span className="order-summary-emphasis" >
                                                               {formatPrice(order.grand_total)} ₫
                                                            </span>
                                                         </td>
                                                      </tr>
                                                      <tr className="total-line total-line-shipping">
                                                         <td className="total-line-name">Phí vận chuyển</td>
                                                         <td className="total-line-price">
                                                            <span className="order-summary-emphasis">
                                                               {formatPrice(order.shipping)} ₫
                                                            </span>
                                                         </td>
                                                      </tr>
                                                   </tbody>
                                                   <tfoot className="total-line-table-footer">
                                                      <tr className="total-line">
                                                         <td className="total-line-name payment-due-label">
                                                            <span className="payment-due-label-total">Tổng cộng</span>
                                                         </td>
                                                         <td className="total-line-name payment-due">
                                                            <span className="payment-due-currency">VND</span>
                                                            <span className="payment-due-price">
                                                               {formatPrice(order.grand_total)} ₫
                                                            </span>
                                                            <span className="checkout_version" data_checkout_version="0">
                                                            </span>
                                                         </td>
                                                      </tr>
                                                   </tfoot>
                                                </table>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            :
            <React.Fragment>
               {!isLoad && <NotFound />}
            </React.Fragment>
         }
      </React.Fragment>
   )
}

const mapStateToProps = (state) => {
   const { order } = state;
   return {
      order
   };
};

export default connect(mapStateToProps, {
   fetchOrder
})(ThankYou)

